import React from 'react';
import {
  Modal, ModalBody, Label, FormGroup, FormFeedback,
} from 'reactstrap';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { customStyles, customStylesTotal } from '../../../utils/functions';
import TouchedInput from '../../../shared/components/form/TouchedInput';

const ModalContact = ({
  toggle, isModal, data, assetData,
}) => {
  const { category } = assetData;
  const isCompany = category === 'company';
  const listRoles = isCompany ? [
    { value: 'accountant', label: 'Comptable' },
    { value: 'banker', label: 'Banquier' },
    { value: 'lawyer', label: 'Avocat' },
    { value: 'wealth_manager', label: 'Gestionnaire' },
    { value: 'other', label: 'Autre' },
  ] : [
    { value: 'trustee', label: 'Syndic' },
    { value: 'agency', label: 'Agence' },
    { value: 'accountant', label: 'Comptable' },
    { value: 'banker', label: 'Banquier' },
    { value: 'lawyer', label: 'Avocat' },
    { value: 'wealth_manager', label: 'Gestionnaire' },
    { value: 'other', label: 'Autre' },
  ];
  console.log(data);
  const {
    full_name, email, company, phone, notes,
  } = data;
  const role = data.role.value === 'other' ? { ...data.role, label: data.role.label || '' } : data.role;
  const isOther = !role || (role && role.value === 'other');

  return (
    <Modal
      isOpen={isModal}
      toggle={toggle}
      modalClassName="ltr-support"
      className="modal-dialog--lightOfficial modal-dialog--header theme-light"
    >
      <div className="modal__header with-border">
        <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
        <h4 className="semiBold text-modal modal__title">
          Informations contact
        </h4>
      </div>
      <ModalBody>
        <div className="form">
          <FormGroup className="form__form-group">
            <Label className="form__form-group-label">Nom complet</Label>
            <TouchedInput
              invalid={full_name.length === 0}
              valid={full_name.length > 0}
              type="text"
              placeholder=""
              required
              value={full_name}
              name="full_name"
              className="form__form-group-field priority"
              maxLength="50"
              disabled
            />
            <FormFeedback>Le nom ne peut être vide</FormFeedback>
          </FormGroup>

          <FormGroup className="form__form-group">
            <Label className="form__form-group-label">Cabinet / Entreprise</Label>
            <TouchedInput
              type="text"
              placeholder=""
              required
              value={company}
              name="company"
              className="form__form-group-field priority"
              maxLength="50"
              disabled
            />
          </FormGroup>

          <FormGroup className="form__form-group">
            <Label className="form__form-group-label">Adresse email</Label>
            <TouchedInput
              type="email"
              placeholder=""
              required
              value={email}
              name="email"
              className="form__form-group-field priority"
              maxLength="100"
              disabled
            />
            <FormFeedback>
              Format d'email invalide
            </FormFeedback>
          </FormGroup>

          <FormGroup className="form__form-group">
            <Label className="form__form-group-label">Téléphone</Label>
            <TouchedInput
              type="text"
              placeholder=""
              required
              value={phone}
              name="phone"
              className="form__form-group-field priority"
              maxLength="100"
              disabled
            />
          </FormGroup>

          {
            isOther ? (
              <FormGroup className="form__form-group">
                <Label className="form__form-group-label">Rôle / Profession</Label>
                <TouchedInput
                  type="text"
                  placeholder=""
                  required
                  value={role.label}
                  name="role"
                  className="form__form-group-field priority"
                  maxLength="50"
                  disabled
                />
              </FormGroup>
            ) : (
              <div className="form__form-group">
                <span className="form__form-group-label">Rôle / Profession</span>
                <div className="form__form-group-field priority">
                  <Select
                    // options={[]}
                    name="role"
                    defaultValue={listRoles.find(e => e.value === role.value)}
                    className="fullWidth disabled"
                    placeholder="Sélectionner..."
                    theme={customStyles}
                    styles={customStylesTotal}
                    isDisabled
                    disabled
                  />
                </div>
              </div>
            )
          }

          <div className="form__form-group">
            <span className="form__form-group-label">Informations complémentaires</span>
            <div className="form__form-group-field">
              <textarea
                placeholder="Vous pouvez ici préciser son rôle, sa fonction, ou toute autre information susceptible d'aider lors de votre succession."
                style={{ height: 70, minHeight: 70 }}
                value={notes}
                name="notes"
                maxLength="2000"
                disabled
              />
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

ModalContact.propTypes = {
  toggle: PropTypes.func.isRequired,
  isModal: PropTypes.bool.isRequired,
  data: PropTypes.shape({}).isRequired,
  assetData: PropTypes.shape({}).isRequired,
};

export default ModalContact;
